(() => {
  if (window.ecomhardCouponCopyInitialized) return;
  window.ecomhardCouponCopyInitialized = true;

  const fallbackCopy = (text) => {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    textarea.style.pointerEvents = 'none';
    document.body.appendChild(textarea);
    textarea.select();
    textarea.setSelectionRange(0, text.length);

    let copied = false;
    try {
      copied = document.execCommand('copy');
    } catch (error) {
      copied = false;
    }

    textarea.remove();
    return copied;
  };

  const copyCoupon = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch (error) {
        return fallbackCopy(text);
      }
    }

    return fallbackCopy(text);
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-ecomhard-coupon-copy]');
    if (!button) return;

    const coupon = button.dataset.coupon || '';
    const label = button.querySelector('[data-ecomhard-coupon-button-label]');
    if (!coupon || !label) return;

    const copied = await copyCoupon(coupon);
    if (!copied) return;

    const copyLabel = button.dataset.labelCopy || 'Copiar';
    const copiedLabel = button.dataset.labelCopied || 'Copiado!';

    label.textContent = copiedLabel;
    button.setAttribute('aria-label', `${copiedLabel}: ${coupon}`);

    window.clearTimeout(button.ecomhardCouponTimer);
    button.ecomhardCouponTimer = window.setTimeout(() => {
      label.textContent = copyLabel;
      button.setAttribute('aria-label', `${copyLabel}: ${coupon}`);
    }, 2000);
  });
})();
